import LongHuDouTableSound from "../../longhudou/module/longhudou_table_sound";
import AudioManager from "../../../manager/audio_manager";
const bjlPath:string = "package/longhudou/sound/bjl/"
const bpPath: string = 'package/bipai/sound/'
const cpPath:string = "package/yxx/sound/cp/"
// Learn TypeScript:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/typescript.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/reference/attributes.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/life-cycle-callbacks.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/life-cycle-callbacks.html

const {ccclass, property} = cc._decorator;

@ccclass
export default class BJLSoundCtr extends LongHuDouTableSound {
    WinByResuleType = ["bjl_player_win", "bjl_banker_win", "bjl_he"]

    //播放结果 1 闲 2 庄 3 和
    playerWin(winType){
        let name = this.WinByResuleType[winType - 1]
        if (name == null) { return }
        this.playSound(bjlPath + name, name)
    }

    //播放对子
    playDuizi(isBanker, callBack){
        let name = isBanker ? "bjl_banker_duizi" : "bjl_player_duizi"
        if (name == null) { return }
        this.playSound(bjlPath + name, name, callBack)
    }

    //播放补牌
    playBuPai(isBanker, callBack){
        let name = isBanker ? "bjl_banker_add" : "bjl_palyer_add"
        if (name == null) { return }
        this.playSound(bjlPath + name, name, callBack)
    }

    playOpenResult(){
        let name = "open_box"
        this.playSound(cpPath + name, name)  
    }

    playFaPai(callBack){
        let name = "fk_take_card"
        this.playSound(bpPath + name, name, callBack)
    }


    playStartOrBetBet(isStart){        
        let name = isStart ? "bjl_start_bet" : "bjl_stop_bet"
        this.playSound(bjlPath + name, name)
    }

    playBgm(){
        AudioManager.instance.playMusic(bjlPath + 'bgm/bai_jia_le', false);
    }
}
